import * as React from "react";
import styled from "../../../styled/index";
import { BaseInputCSS } from "../input/index";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: Array<{ label: string, value: string; disabled?: boolean; }>;
}

const SelectComponent = styled("select")<SelectProps>`
  ${BaseInputCSS};
  option {
    padding: 5px 0;
    &:disabled {
      background-color: darken(white, 15%);
    }
  }
`;

export const Select = (props: SelectProps) => (
  <SelectComponent {...props}>
    {props.placeholder && <option value="">{props.placeholder || ""}</option>}
    {props.options.map((o, i) => {
      return (<option key={i} value={o.value} disabled={o.disabled || false}>{o.label}</option>);
    })}
  </SelectComponent>
);
